export enum BulkUploadActionType {
  ADD_UPLOADS = 'ADD_UPLOADS',
  REMOVE_UPLOAD = 'REMOVE_UPLOAD',
  REMOVE_QUEUED_UPLOADS = 'REMOVE_QUEUED_UPLOADS',
  MOVE_QUEUED_TO_UPLOADING = 'MOVE_QUEUED_TO_UPLOADING',
  MOVE_UPLOADING_TO_REJECTED = 'MOVE_UPLOADING_TO_REJECTED',
  MOVE_REJECTED_TO_QUEUED = 'MOVE_REJECTED_TO_QUEUED',
}
